/** Client-side “Show more” paging: first N items, then grow `shown` by the step. */

export const DASHBOARD_SHOW_MORE_STEP = 10;
export const LIVE_STATUS_SHOW_MORE_STEP = 8;

/** First `shown` items of `list`. Non-finite or non-positive `shown` yields []. */
export function visibleSlice<T>(list: readonly T[], shown: number): T[] {
  if (!Number.isFinite(shown) || shown <= 0) return [];
  return list.slice(0, Math.floor(shown));
}

/** How many items the next Show more click will reveal (last page may be smaller). */
export function showMoreNext(remaining: number, step: number): number {
  if (!Number.isFinite(remaining) || remaining <= 0) return 0;
  if (!Number.isFinite(step) || step <= 0) return 0;
  return Math.min(Math.floor(remaining), Math.floor(step));
}
